import styled from 'styled-components'
import * as SliderPrimitive from '@radix-ui/react-slider'

export const Field = styled.div`
  --thumb: 18px;

  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.default};
  width: 100%;
  min-width: 0;
  color: ${({ theme }) => theme.colors.text.primary};

  &[data-disabled] {
    ${() => Label}, ${() => Value}, ${() => ScaleLabel} {
      color: ${({ theme }) => theme.colors.text.tertiary};
    }
  }

  &[data-orientation='vertical'] {
    width: auto;
    align-items: center;

    ${() => Header} {
      width: 100%;
    }

    ${() => Body} {
      flex-direction: row;
      align-items: stretch;
      width: auto;
      height: 160px;
      gap: ${({ theme }) => theme.spacing.small};
    }

    ${() => Control} {
      flex-direction: column;
      width: var(--thumb);
      height: 100%;
    }

    ${() => Track} {
      width: 4px;
      height: 100%;
    }

    ${() => Range} {
      width: 100%;
    }

    ${() => Mark} {
      width: 8px;
      height: 2px;
    }

    ${() => Scale} {
      height: 100%;
      width: 28px;
      margin-top: 0;
    }

    ${() => ScaleLabel} {
      top: auto;
      left: 0;
    }
  }
`

export const Header = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.medium};
  min-height: 20px;
`

export const Label = styled.span`
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  line-height: 20px;
`

export const Value = styled.span`
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  line-height: 20px;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
`

export const Control = styled(SliderPrimitive.Root)`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--thumb);
  touch-action: none;
  user-select: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &[data-disabled] {
    cursor: not-allowed;
    opacity: 0.45;
  }
`

export const Track = styled(SliderPrimitive.Track)`
  position: relative;
  flex-grow: 1;
  height: 4px;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  background: ${({ theme }) => theme.colors.border.default};
`

export const Range = styled(SliderPrimitive.Range)`
  position: absolute;
  height: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  background: ${({ theme }) => theme.colors.primary};
`

export const Thumb = styled(SliderPrimitive.Thumb)`
  display: block;
  width: var(--thumb);
  height: var(--thumb);
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  background: ${({ theme }) => theme.colors.background.primary};
  box-shadow: ${({ theme }) => theme.shadows.md};
  cursor: grab;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.border.focus};
    outline-offset: 2px;
  }

  &:active {
    cursor: grabbing;
  }
`

export const Mark = styled.span`
  position: absolute;
  width: 2px;
  height: 8px;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  background: ${({ theme }) => theme.colors.text.tertiary};
  pointer-events: none;
`

export const Scale = styled.div`
  position: relative;
  height: 16px;
  margin-top: ${({ theme }) => theme.spacing.micro};
`

export const ScaleLabel = styled.span`
  position: absolute;
  top: 0;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-size: ${({ theme }) => theme.typography.fontSize.label};
  line-height: 16px;
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`
